<template>
    <component
        :is="as"
        :type="buttonType"
        class="button icon-only"
        :class="{ floating, dense }"
        :aria-label="ariaLabel"
        v-on="$listeners"
    >
        <slot>
            <Icon :name="name" />
        </slot>
    </component>
</template>

<script>
import { Icon } from '../Icon';

export default {
    name: 'DsIconButton',

    components: { Icon },

    props: {
        /**
         * Icon name to render
         */
        name: String,

        /**
         * Name of the element type to render the Button as.  Defaults to a button element, but can be used to render an anchor for links that look like buttons.
         */
        as: {
            type: String,
            default: 'button',
        },

        /**
         * The type attribute used by the rendered button, i.e. button, submit, reset.  Defaults to button.  This will not be used if the `as` prop is overriden.
         */
        type: String,

        /**
         * Style as floating
         */
        floating: Boolean,

        /**
         * Label to render for screen readers
         * https://dequeuniversity.com/rules/axe/3.5/button-name?application=axeAPI
         */
        ariaLabel: String,

        /**
         * Styles as a dense variant.
         */
        dense: Boolean,
    },

    computed: {
        buttonType() {
            if (this.as !== 'button') {
                return null;
            }

            if (this.type === undefined) {
                return 'button';
            }

            return this.type || null;
        },
    },
};
</script>
